import { render, staticRenderFns } from "./BaseInputToggle.vue?vue&type=template&id=bea15b7a&scoped=true&"
import script from "./BaseInputToggle.vue?vue&type=script&lang=js&"
export * from "./BaseInputToggle.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./BaseInputToggle.vue?vue&type=style&index=0&id=bea15b7a&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "bea15b7a",
  null
  ,true
)

export default component.exports